﻿import { apiPromise, htmlPromise } from '../../../../Resources/Scripts/_Shared/fetch'

export const prePaidBooking = {
  getPrePaidBookingInformation: async (data) => htmlPromise(`${data.PermitPageUrl?.length > 0 ? data.PermitPageUrl : window.location.pathname}/GetPrePaidBookingOverlay`, data).catch((err) => err),
}
